module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9549.19d0ea64.jpg";